module.exports = new __parcel__URL__("cobblestone.25f8742f.webp").toString();